import api, { getApiToken } from './api';

/** Which integrations are active for the logged-in member. */
export const getIntegrationStatus = () =>
  api.get('/integrations/status').then(r => r.data);

/** This member's own synced Google Calendar events (today by default). */
export const getMyCalendarEvents = (days = 1) =>
  api.get('/integrations/calendar-events', { params: { days } }).then(r => r.data.events);

// Kicking off an OAuth connect has to be a real top-level page navigation —
// the browser needs to actually leave the app and land on Google's consent
// screen, which a fetch/XHR call (and its Authorization header) can't do.
// The access token rides along as a query param instead, verified server-side
// by requireAuthFromQuery (see auth.middleware.js) — the one deliberate
// exception to header-only auth in this app, and only for these two routes.

/** Kick off Google Calendar OAuth — backend redirects browser to Google. */
export const connectGoogle = () => {
  window.location.href = `${api.defaults.baseURL}/integrations/google/connect?token=${encodeURIComponent(getApiToken())}`;
};

/** Kick off Google Health OAuth — backend redirects browser to Google. */
export const connectGoogleHealth = () => {
  window.location.href = `${api.defaults.baseURL}/integrations/google-health/connect?token=${encodeURIComponent(getApiToken())}`;
};

/** Disconnect an integration by service name. */
export const disconnectIntegration = (service) =>
  api.delete(`/integrations/${service}/disconnect`).then(r => r.data);

/** One of the 3 real calendar opt-ins — pass exactly one field, e.g. { pushWhatOnTap: true }. Returns { preference, warning }. */
export const setCalendarPreference = (field) =>
  api.put('/integrations/google-calendar/preferences', field).then(r => r.data);

/** Two-way check-off sync with Google, right now. Returns { synced, changedApp, changedGoogle }. */
export const syncGoogleTasksNow = () =>
  api.post('/integrations/google/sync-now').then(r => r.data);
